/**
 * Ссылка на карточку человека — Блок 2 · Ф8 · В-Э.
 *
 * Карточка — окно страницы «Сотрудники», своего адреса у неё нет; открывает её
 * одноразовый параметр `card`. Имя параметра и сборка ссылки живут в одном
 * месте: страница его читает, сводный список прав по нему ведёт — две копии
 * строки `'card'` однажды разошлись бы молча, ссылкой, которая открывает
 * список вместо человека.
 */
export const EMPLOYEE_CARD_PARAM = 'card';

export function employeeCardHref(userId: string): string {
  return `/employees?${EMPLOYEE_CARD_PARAM}=${encodeURIComponent(userId)}`;
}
